import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { applicationsApi } from 'store/api';

enum ActiveBorrowerInformationActionType {
  GetCurrentApplication = 'applications/getCurrentApplication',
}

export const getCurrentApplication = createAsyncThunk(
  ActiveBorrowerInformationActionType.GetCurrentApplication, () => {
    return applicationsApi.getCurrentApplication();
  },
);

export interface IActiveBorrowerInformationState {
  currentApplication?: string | null;
}

const initialState: IActiveBorrowerInformationState = {
  currentApplication: undefined,
};

export const resetCurrentApplication = createAction('activeBorrowerInformation/resetCurrentApplication');

const activeBorrowerInformationSlice = createSlice({
  name: 'activeBorrowerInformation',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCurrentApplication.fulfilled, (state, { payload }) => {
        state.currentApplication = payload?.id || null;
      })
      .addCase(resetCurrentApplication, (state) => {
        state.currentApplication = undefined;
      });
  },
});

export default activeBorrowerInformationSlice.reducer;
